<template>
    <div class="row px-4" v-if="attributes.length">
        <h1 class="fs-5 mb-3">კალენდარი</h1>
        <v-calendar
            class="custom-calendar w-100 rounded-3"
            :firstDayOfWeek="firstDayOfWeek"
            :locale="locale"
            :attributes="attributes"
            disable-page-swipe
            is-expanded
        >
            <template v-slot:day-content="{ day, attributes }">
                <div
                    class="d-flex flex-column h-100 min-height overflow-hidden border p-2"
                >
                    <span class="text-sm">{{ day.day }}</span>
                    <div
                        class="d-flex flex-column overflow-y-auto overflow-x-auto"
                    >
                        <p
                            v-for="attribute in attributes"
                            :key="attribute.key"
                            class="text-xs rounded shadow-sm p-1 mt-0 mb-1"
                            :class="
                                attribute.customData.class === 'approved' &&
                                moment(attribute.customData.endDate).format(
                                    'YYYY-MM-DD'
                                ) < moment().format('YYYY-MM-DD')
                                    ? 'bg-primary text-white'
                                    : attribute.customData.class === 'approved'
                                    ? 'bg-success text-white'
                                    : attribute.customData.class === 'rejected'
                                    ? 'bg-danger text-white'
                                    : 'bg-warning text-white'
                            "
                        >
                            {{ attribute.customData.title }}
                            <span
                                v-if="attribute.customData.maternity"
                                class="badge bg-info ms-1 shadow-sm"
                                >დეკრეტული</span
                            >
                        </p>
                    </div>
                </div>
            </template>
        </v-calendar>
    </div>
</template>

<script>
import { getVacations } from "../Services/ApiService";
import moment from "moment";

export default {
    name: "VacationsCalendar",
    data() {
        return {
            params: {
                status: null,
                operator_id: null,
                from: null,
                to: null,
                orderBy: "created_at",
                orderDirection: "desc",
            },
            attributes: [],
            locale: {
                masks: {
                    weekdays: "WWW",
                },
                firstDayOfWeek: 2,
            },
            moment,
        };
    },
    mounted() {
        this.getVacationsList(this.params);
    },
    watch: {
        params: {
            handler() {
                this.getVacationsList(this.params);
            },
            deep: true,
        },
    },
    methods: {
        getVacationsList(params) {
            getVacations(params).then((response) => {
                // Get vacations from response
                let vacations = response.data.data;

                // Set attributes for calendar
                this.attributes = vacations.map((vacation) => {
                    return {
                        key: vacation.id,
                        customData: {
                            title: vacation.operator.name,
                            class: vacation.status,
                            endDate: vacation.to,
                            maternity: vacation.is_maternity_leave,
                        },
                        dates: { start: vacation.from, end: vacation.to },
                    };
                });
            });
        },
    },
};
</script>

<style scoped>
::-webkit-scrollbar {
    width: 0px;
}
::-webkit-scrollbar-track {
    display: none;
}
/deep/ .custom-calendar.vc-container {
    --day-border: 1px solid #b8c2cc;
    --day-border-highlight: 1px solid #b8c2cc;
    --day-width: 90px;
    --day-height: 90px;
    --weekday-bg: #f8fafc;
    --weekday-border: 1px solid #eaeaea;
    border-radius: 0;
    width: 100%;
    & .vc-header {
        background-color: #f1f5f8;
        padding: 10px 0;
    }
    & .vc-weeks {
        padding: 0;
    }
    & .vc-weekday {
        background-color: var(--weekday-bg);
        border-bottom: var(--weekday-border);
        border-top: var(--weekday-border);
        padding: 5px 0;
    }
    & .vc-day {
        padding: 0 5px 3px 5px;
        text-align: left;
        height: var(--day-height);
        min-width: var(--day-width);
        background-color: white;
        &.weekday-1,
        &.weekday-7 {
            background-color: #eff8ff;
        }
        &:not(.on-bottom) {
            border-bottom: var(--day-border);
            &.weekday-1 {
                border-bottom: var(--day-border-highlight);
            }
        }
        &:not(.on-right) {
            border-right: var(--day-border);
        }
    }
    & .vc-day-dots {
        margin-bottom: 5px;
    }
}

.min-height {
    min-height: 120px;
}
</style>
